import { AbstractStorage } from "./AbstractStorage.js";
class SyncedStorage extends AbstractStorage {
  childStore;
  constructor(store, childStore) {
    super(store);
    this.childStore = childStore;
  }
  get(key) {
    const value = this.store.get(key);
    if (this.childStore.get(key) !== value) {
      this.childStore.set(key, value);
    }
    return value;
  }
  set(key, value) {
    this.store.set(key, value);
    this.childStore.set(key, value);
  }
  has(key) {
    return this.store.has(key);
  }
  delete(key) {
    this.store.delete(key);
    this.childStore.delete(key);
  }
}
export {
  SyncedStorage
};
//# sourceMappingURL=SyncedStorage.js.map
